/* eslint-disable react-hooks/exhaustive-deps */
import  React, { useState } from 'react';

import { Toast, Container, Row, Button, Collapse, Col, Overlay, Spinner } from 'react-bootstrap';
import graphQLClientInstance from '../../../axios-graphql-client';
import {
  getVarietyDataSheetQuery,
  varietyStatus,
  convertDate,
  GLOBAL_DATE_FORMAT,
  downloadBlob,
  prefixCheck,
  denominationStatusMatching,
  downloadPdfFileNames,
  API_URLS,
  varietyDataSheetRegions,
  APP_URLS,
  getProtectedDesignation
} from '../../../shared/utility';
import classes from './VarietyDataSheet.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import logo from '../../../logo.svg';

import { pdf } from '@react-pdf/renderer';
import { VarietyDataSheetPDF } from '../../PDF/VarietyDataSheetPDF/VarietyDataSheetPDF';
import { useParams } from 'react-router-dom';

import clipboard from 'clipboard-copy';
import { FONTAWESOME_ICON_NAMES } from '../../../fontawesome';
import SpeciesClassModal from '../../SpeciesClassModal/SpeciesClassModal';
import useSessionStorage from '../../../hooks/useSessionStorage';
import SpeciesModal from '../../../components/SpeciesModal/SpeciesModal';
import { IActiveRegister, IActiveSpecies } from '../Table/Table';
import RegistersModal from '../../RegistersModal/RegistersModal';
import Loader from '../Loader/Loader';

const VarietyDataSheet = (props: any) => {
  const { t, i18n } = useTranslation();
  const params = useParams();
  const [isModal, setIsModal] = useState(true);
  const overlayTarget = React.useRef(null);
  const [copySuccess, setCopySuccess] = useState(false);

  let {
      countryid,
      publicationextraid,
      publicationtype,
      currentIndex,
      totalIndex,
      totalCount,
      varietyDataSheetPrevious,
      varietyDataSheetNext,
      varietyid,
      fromArrow,
      fromSearchVarieties,
      name
  } = props;

  const [shareUrl, setShareUrl] = useState(
    `${window.location.origin}${APP_URLS.SEARCH_VARIETIES}/${countryid}-${publicationextraid}-${publicationtype}-${varietyid}?lang=${i18n.language}`
  );

  const [data, setData] = useState({});
  const [error, setError] = useState(false);
  const [loaderModalIsLoading, setLoaderModalIsLoading] = React.useState(false);

  const dataToRender = JSON.parse(JSON.stringify(data));

  const denominationsList = JSON.parse(dataToRender.denominationsList?dataToRender.denominationsList:"{}").denos;

  const denominationsArray = denominationsList?.filter((item: any) => item.nature === "Denomination");
  const synonymsArray = denominationsList?.filter((item: any) => item.nature === "Synonym");
  const tradenamesArray = denominationsList?.filter((item: any) => item.nature === "Trade name");
  const trademarksArray = denominationsList?.filter((item: any) => item.nature === "Trade mark");

  const loaderModal = (
    <Loader show={loaderModalIsLoading}></Loader>
  )

  React.useEffect(() => {

    if (Object.keys(params).length && (params as IVarietyDataSheetParams).varietyid) {
      setIsModal(false);
      countryid = (params as IVarietyDataSheetParams).countryid;
      publicationextraid = (params as IVarietyDataSheetParams).publicationextraid;
      publicationtype = (params as IVarietyDataSheetParams).publicationtype;
      varietyid = (params as IVarietyDataSheetParams).varietyid;
      name = (params as IVarietyDataSheetParams).name;
      setShareUrl(window.location.origin+`${APP_URLS.SEARCH_VARIETIES}/${countryid}-${publicationextraid}-${publicationtype}-${varietyid}?lang=${i18n.language}`)
    }

    setError(false);

    graphQLClientInstance.post(API_URLS.GRAPHQL, getVarietyDataSheetQuery(varietyid))
    .then(res => {
      if (res.data.data.varietyDatasheet) {
        setData({
            ...res.data.data.varietyDatasheet,
            protectedDesignation: getProtectedDesignation(res.data.data.varietyDatasheet.countryid, res.data.data.varietyDatasheet.publicationtypeid, res.data.data.varietyDatasheet.publicationextraid)
          });
        countryid = res.data.data.varietyDatasheet.countryid;
        publicationextraid = res.data.data.varietyDatasheet.publicationextraid;
        publicationtype = res.data.data.varietyDatasheet.publicationtypeid;
        name = res.data.data.varietyDatasheet.name;
        setShareUrl(`${window.location.origin}${APP_URLS.SEARCH_VARIETIES}/${countryid}-${publicationextraid}-${publicationtype}-${varietyid}?lang=${i18n.language}`)
      } else {
        setError(true);
      }
    })
    .catch(err => {
      setError(true);
      console.log(err);
    });
  }, [params]);

  const collapseSummary = (openState: boolean, inp: any) => {
    if(!openState) {
      return inp
    } else {
    return " "
    }
  }

  const initialSelectedRegions = [
    {
      name: varietyDataSheetRegions.DATA_SHEET,
      enabled: true
    },
    {
      name: varietyDataSheetRegions.NAMES,
      enabled: true
    },
    {
      name: varietyDataSheetRegions.REGISTER,
      enabled: true
    },
    {
      name: varietyDataSheetRegions.SPECIES,
      enabled: true
    },
    {
      name: varietyDataSheetRegions.REGISTRATION_STATUS,
      enabled: true
    },
    {
      name: varietyDataSheetRegions.PARTIES,
      enabled: true
    },
    {
      name: varietyDataSheetRegions.ADDITIONAL_INFO,
      enabled: true
    },
  ]

  const getStateFromLocal = (regionName: string, fromArrowState: boolean) => {
    if (!fromArrowState) {
      return true;
    }

    const localRegion = localRegions.find((e: { name: string; }) => e.name === regionName)
    return localRegion?localRegion.enabled:true;
  }

  const [localRegions, setLocalRegions] = useSessionStorage('Regions',
                                                              initialSelectedRegions.map(item => {
                                                                                                  return {name: item.name, enabled: item?.enabled};
                                                                                                 }));
  const [openNames, setOpenNames] = useState(getStateFromLocal(varietyDataSheetRegions.NAMES, fromArrow));
  const [openRegionRegister, setOpenRegionRegister] = useState(getStateFromLocal(varietyDataSheetRegions.REGISTER, fromArrow));
  const [openRegionSpecies, setOpenRegionSpecies] = useState(getStateFromLocal(varietyDataSheetRegions.SPECIES, fromArrow));
  const [openRegionRegistrationStatus, setOpenRegionRegistrationStatus] = useState(getStateFromLocal(varietyDataSheetRegions.REGISTRATION_STATUS, fromArrow));
  const [openRegionParties, setOpenRegionParties] = useState(getStateFromLocal(varietyDataSheetRegions.PARTIES, fromArrow));
  const [openRegionAdditionalInformation, setOpenRegionAdditionalInformation] = useState(getStateFromLocal(varietyDataSheetRegions.ADDITIONAL_INFO, fromArrow));

  React.useEffect(() => {
    setLocalRegions([
      { name: varietyDataSheetRegions.NAMES, enabled: openNames },
      { name: varietyDataSheetRegions.REGISTER, enabled: openRegionRegister },
      { name: varietyDataSheetRegions.SPECIES, enabled: openRegionSpecies },
      { name: varietyDataSheetRegions.REGISTRATION_STATUS, enabled: openRegionRegistrationStatus },
      { name: varietyDataSheetRegions.PARTIES, enabled: openRegionParties },
      { name: varietyDataSheetRegions.ADDITIONAL_INFO, enabled: openRegionAdditionalInformation }
    ]);
  }, [ openNames, openRegionRegister, openRegionSpecies, openRegionRegistrationStatus, openRegionParties, openRegionAdditionalInformation]);

  const [classModalState, setClassModalState] = useState(false);
  const [activeClassId, setActiveClassId] = useState<string | null>(null);
  React.useEffect(() => {
    if (!activeClassId) {
      return;
    }

    setClassModalState(true);
  }, [activeClassId]);

  const classModal = (
    <SpeciesClassModal
      show={classModalState}
      setShow={setClassModalState}
      classid={activeClassId}
    />
  );

  const [speciesModalState, setSpeciesModalState] = useState(false);
  const [activeSpecies, setActiveSpecies] = useState<IActiveSpecies | null>(
    null
  );

  React.useEffect(() => {
    if (!activeSpecies) {
      return;
    }

    setSpeciesModalState(true);
  }, [activeSpecies]);

  const speciesModal = (
    <SpeciesModal
      show={speciesModalState}
      setShow={setSpeciesModalState}
      princ_bot={activeSpecies?.princ_bot}
      species_id={activeSpecies?.species_id}
    />
  );

  const [registerModalState, setRegisterModalState] = useState(false);
  const [activeRegister, setActiveRegister] = useState<IActiveRegister | null>(null);

  React.useEffect(() => {
    if (!activeRegister) {
      return;
    }

  setRegisterModalState(true);
  }, [activeRegister]);

  const registersModal = (
    <RegistersModal
      show={registerModalState}
      setShow={setRegisterModalState}
      publicationtypeid={activeRegister?.publicationtypeid}
      publicationextraid={activeRegister?.publicationextraid}
      countryid = {activeRegister?.countryid}
    />
  );

  const getNamesSectionClasses = (index: number, length: number) => {
    const sectionClasses = [];

    if (index === length - 1) {
      sectionClasses.push("border-0");
    }
    if (index === 0){
      sectionClasses.push("pt-0");
    }

    return sectionClasses;
  }

  return (
      <>
        {classModal}
        {speciesModal}
        {registersModal}
        {loaderModal}
        {isModal?(
          <Container>
            <Row>
              <Col md="8" className={classes.dataSheetActions}>
              {Object.keys(data).length?(
                <>
                  <Button onClick={() => {
                      setLoaderModalIsLoading(true);
                      // @ts-ignore
                      const myPdf = pdf({});
                      // @ts-ignore
                      myPdf.updateContainer(<VarietyDataSheetPDF data={[{...(data as IVarietyDataSheet)}]} />);
                      myPdf.toBlob().then((blob: any) =>{
                        downloadBlob(blob, downloadPdfFileNames.VARIETY_DATA_SHEET);
                      })
                      .finally(() => setLoaderModalIsLoading(false));
                    }}
                    variant="light">
                      <FontAwesomeIcon style={{marginRight: '5px'}} icon={['fas', 'arrow-alt-circle-down']}/>
                      {t("download_pdf")}
                  </Button>
                  <Button
                    ref={overlayTarget}
                    onClick={() => {
                      setCopySuccess(!copySuccess);
                      clipboard(shareUrl);
                    }}
                    variant="light">
                      <FontAwesomeIcon icon={['fas', 'share-square']} />
                      {t("share_variety_datasheet")}
                  </Button>
                  <Overlay placement="bottom"
                    target={overlayTarget.current}
                    show={copySuccess}
                    >
                    <Toast  onClose={() => setCopySuccess(false)} show={copySuccess} delay={2000} autohide>
                      <Toast.Body>{t("url_copied")}</Toast.Body>
                    </Toast>
                  </Overlay>
                </>
              ):<></>}
            </Col>
            <Col md="4" className={[classes.dataSheetNavigation, "text-right"].join(" ")}>
              <span className={classes.currentCount}>{t("range", {start: totalIndex, end: totalCount})}</span>
              <Button
                onClick={() => varietyDataSheetPrevious({currentIndex: currentIndex})}
                disabled={totalIndex === 1}
                variant="link">
                  <FontAwesomeIcon icon={['fas', 'chevron-left']} className={classes.dataSheetChevron} />
              </Button>
              <Button
                onClick={() => varietyDataSheetNext({currentIndex: currentIndex})}
                disabled={totalIndex === totalCount}
                variant="link">
                  <FontAwesomeIcon icon={['fas', 'chevron-right']} className={classes.dataSheetChevron} />
              </Button>
            </Col>
            </Row>
          </Container>
        ):<></>}
        {Object.keys(data).length?(
        <>
          <Container className={[classes.collapsibleContent, (props.standAlone ? "mt-3": ""), (props.standAlone ? classes.dialog: "")].join(" ")}>
            <Row className={classes.header}>
              <Col md="1">
                <a href="https://cpvo.europa.eu/en" target = "_blank">
                  <img src={logo} width="30" height="30" alt="CPVO Website"/>
                </a>
              </Col>
              <Col md="8">
                <span>
                    {dataToRender.protectedDesignation ? t(`datasheet.${dataToRender.protectedDesignation}`) : (dataToRender.publicationtypeid === "EUTM" ? t("datasheet.eutm"): t("datasheet.variety"))}
                </span>
              </Col>
              <Col md="3">
                {props.standAlone?(<a href={process.env.REACT_APP_LOGIN_URL!} target='_blank' >Go to Variety Finder</a>):<></>}
              </Col>
            </Row>
              <Row className={classes.body}>
                <Container className={classes.region}>
                  <Row className={classes.regionHeader}>
                    <Col md="3" className={classes.title}>{t("register")}</Col>
                    <Col md="8" className={classes.summary}>
                      {collapseSummary(openRegionRegister,
                                      joinNotEmptyValues(", ", joinNotEmptyValues(" - ", dataToRender.countryid, dataToRender.country),
                                      `${dataToRender.pub_type_name} (${dataToRender.publicationtypeid})`))}
                    </Col>
                    <Col md="1" className={classes.collapseButton}>
                      <Button
                        onClick={() => setOpenRegionRegister(!openRegionRegister)}
                        className={openRegionRegister?"open":""}
                        style={{'padding': '0 5px', 'background': '#E8E8E8', 'borderBottomLeftRadius': '0px', 'borderBottomRightRadius': '0px'}}
                        variant="link">
                          <FontAwesomeIcon icon={['fas', FONTAWESOME_ICON_NAMES.CHEVRON_UP]} className={classes.paginationChevron} />
                      </Button>
                    </Col>
                  </Row>
                  <Collapse in={openRegionRegister}>
                    <Row>
                      <Col md="2" className={[classes.dataSheetResultKeys, classes.registerRegionKeys].join(" ")}>{t("country")}</Col>
                      <Col md="5" className={[classes.dataSheetResultValues, "font-weight-bold"].join(" ")}>{`${dataToRender.countryid} - ${dataToRender.country}`}</Col>

                      <Col md="1" className={[classes.dataSheetResultKeys, classes.registerRegionKeys].join(" ")}>{t("type")}</Col>
                      <Col md="4" className={[classes.dataSheetResultValues, "font-weight-bold"].join(" ")}>
                        {`${dataToRender.pub_type_name} (${dataToRender.publicationtypeid})`}
                      </Col>

                      <Col md="2" className={[classes.dataSheetResultKeys, classes.registerRegionKeys].join(" ")}>{t("name")}</Col>
                      <Col md="10" className={classes.dataSheetResultValues}>
                        <span
                          className={isModal?classes.link:""}
                          onClick={() => {
                            if (isModal) {
                              const register: IActiveRegister = {
                                countryid: dataToRender.countryid,
                                publicationtypeid: dataToRender.publicationtypeid,
                                publicationextraid: dataToRender.publicationextraid
                              }
                              setActiveRegister(register)
                              setRegisterModalState(true)
                              }
                          }}
                        >
                          {dataToRender.pub_name}
                        </span>
                      </Col>

                      <Col md="2" className={[classes.dataSheetResultKeys, classes.registerRegionKeys].join(" ")}>{t("organization")}</Col>
                      <Col md="10" className={classes.dataSheetResultValues}>{dataToRender.name}</Col>

                      <Col md="2" className={[classes.dataSheetResultKeys, classes.registerRegionKeys].join(" ")}>{t("website")}</Col>
                      <Col md="10" className={classes.dataSheetResultValues}>
                        <a target="_blank"  rel="noopener noreferrer" href={prefixCheck(dataToRender.websiteurl)}>{dataToRender.websiteurl}</a>
                      </Col>
                    </Row>
                  </Collapse>
                </Container>
                {(!dataToRender.protectedDesignation && dataToRender.publicationtypeid !== "EUTM") ? (
                <Container className={classes.region}>
                  <Row className={classes.regionHeader}>
                    <Col md="3" className={classes.title}>{t("species")}</Col>
                    <Col md="8" className={classes.summary}>
                      {collapseSummary(openRegionSpecies, dataToRender.species_princ_bot_name)}
                    </Col>
                    <Col md="1" className={classes.collapseButton}>
                      <Button
                        onClick={() => setOpenRegionSpecies(!openRegionSpecies)}
                        className={openRegionSpecies ? "open" : ""}
                        style={{'padding': '0 5px', 'background': '#E8E8E8', 'borderBottomLeftRadius': '0px', 'borderBottomRightRadius': '0px'}}
                        variant="link">
                          <FontAwesomeIcon icon={['fas', FONTAWESOME_ICON_NAMES.CHEVRON_UP]} className={classes.paginationChevron} />
                      </Button>
                    </Col>
                  </Row>
                  <Collapse in={openRegionSpecies}>
                    <Row>
                      <Col md="3" className={classes.dataSheetResultKeys}>{t("principal_botanical_name")}</Col>
                      <Col md="9" className={classes.dataSheetResultValues}>
                        <span
                          className={isModal?classes.link:""}
                          onClick={() => {
                            if (isModal) {
                            const species: IActiveSpecies = {
                              princ_bot: dataToRender.species_princ_bot_name,
                              species_id: dataToRender.species_code
                            }
                            setActiveSpecies(species)
                            setSpeciesModalState(true)
                            }
                          }}>
                          {dataToRender.species_princ_bot_name}
                        </span>
                      </Col>

                      <Col md="3" className={classes.dataSheetResultKeys}>{t("code")}</Col>
                      <Col md="3" className={classes.dataSheetResultValues}>{dataToRender.species_code}</Col>

                      <Col md="1" className={classes.dataSheetResultKeys}>{t("class")}</Col>
                      <Col md="5" className={classes.dataSheetResultValues}>
                        {dataToRender.species_classes?.map((speciesClass: string, index: number) => (
                                                              <React.Fragment key={`species-class-${index}`}>
                                                                <span
                                                                  className={isModal?classes.link:""}
                                                                  onClick={() => {
                                                                    if (isModal) {
                                                                      setActiveClassId(speciesClass);
                                                                      setClassModalState(true);
                                                                    }
                                                                  }}
                                                                >{speciesClass}</span>
                                                                {index<dataToRender.species_classes.length-1?"/":""}
                                                              </React.Fragment>
                                                            ))}
                      </Col>
                    </Row>
                  </Collapse>
                </Container>
                ):(<></>)}
                <Container className={[classes.region, 'reg-status-container'].join(" ")}>
                  <Row className={classes.regionHeader}>
                    <Col md="3" className={classes.title}>{t("registration_status")}</Col>
                    <Col md="8" className={classes.summary}>
                      {collapseSummary(openRegionRegistrationStatus,
                        joinNotEmptyValues(", ",
                          dataToRender.reg_status,
                          regStatusConditionalHeader(dataToRender.reg_status,
                            convertDate(dataToRender.end_date, GLOBAL_DATE_FORMAT, VARIETY_DATASHEET_DATE_FORMAT),
                            convertDate(dataToRender.renewal_date, GLOBAL_DATE_FORMAT, VARIETY_DATASHEET_DATE_FORMAT),
                            convertDate(dataToRender.grant_date, GLOBAL_DATE_FORMAT, VARIETY_DATASHEET_DATE_FORMAT),
                            convertDate(dataToRender.app_date, GLOBAL_DATE_FORMAT, VARIETY_DATASHEET_DATE_FORMAT))))}
                    </Col>
                    <Col md="1" className={classes.collapseButton}>
                      <Button
                        onClick={() => setOpenRegionRegistrationStatus(!openRegionRegistrationStatus)}
                        className={openRegionRegistrationStatus?"open":""}
                        style={{'padding': '0 5px', 'background': '#E8E8E8', 'borderBottomLeftRadius': '0px', 'borderBottomRightRadius': '0px'}}  variant="link">
                          <FontAwesomeIcon icon={['fas', FONTAWESOME_ICON_NAMES.CHEVRON_UP]} className={classes.paginationChevron} />
                      </Button>
                    </Col>
                  </Row>
                  <Collapse in={openRegionRegistrationStatus}>
                    <Row>
                      {dataToRender.protectedDesignation || (dataToRender.publicationtypeid === "EUTM") ? (
                        <Col md="2" className={[classes.dataSheetResultKeys, "font-weight-bold"].join(" ")}>{t("status")}</Col>
                      ) : (
                        <Col md="2" className={[classes.dataSheetResultKeys, "font-weight-bold", 'var-status'].join(" ")}>{t("variety_status")}</Col>
                      )}

                      <Col md="10" className={[classes.dataSheetResultValues, "font-weight-bold"].join(" ")}>{dataToRender.reg_status}</Col>

                      <Col md="12" className={[classes.dataSheetResultValues, "font-weight-bold reg-application"].join(" ")}>{t("application")}</Col>

                      <Col md="2" className={[classes.dataSheetResultKeys, "reg-app-number"].join(" ")}>{t("number")}</Col>
                      <Col md="4" className={[classes.dataSheetResultValues, "font-weight-bold"].join(" ")}>
                        {dataToRender.applicationnumber}
                      </Col>

                      {(!dataToRender.protectedDesignation && dataToRender.publicationtypeid !== "EUTM") ? (
                        <>
                          <Col md="2" className={classes.dataSheetResultKeys}>{t("breeders_reference")}</Col>
                          <Col md="4" className={classes.dataSheetResultValues}>{dataToRender.breeder_ref}</Col>
                        </>
                        ) : (
                        <Col md="6"></Col>
                      )}

                      <Col md="2" className={[classes.dataSheetResultKeys, "reg-app-date"].join(" ")}>{t("date")}</Col>
                      <Col md="4" className={[classes.dataSheetResultValues, "font-weight-bold"].join(" ")}>
                        {convertDate(dataToRender.app_date, GLOBAL_DATE_FORMAT, VARIETY_DATASHEET_DATE_FORMAT)}
                      </Col>

                      <Col md="2" className={[classes.dataSheetResultKeys, "reg-app-pub-date"].join(" ")}>{t("publication_date")}</Col>
                      <Col md="4" className={classes.dataSheetResultValues}>
                        {convertDate(dataToRender.app_pub_date, GLOBAL_DATE_FORMAT, VARIETY_DATASHEET_DATE_FORMAT)}
                      </Col>

                      <Col md="12" className={[classes.dataSheetResultValues, "font-weight-bold", "grant-registration"].join(" ")}>{t("grant_registration")}</Col>

                      <Col md="2" className={[classes.dataSheetResultKeys, "grant-reg-number"].join(" ")}>{t("number")}</Col>
                      <Col md="4" className={[classes.dataSheetResultValues, "font-weight-bold"].join(" ")}>
                        {dataToRender.grant_number}
                      </Col>

                      <Col md="2" className={[classes.dataSheetResultKeys, "grant-reg-date"].join(" ")}>{t("date")}</Col>
                      <Col md="4" className={[classes.dataSheetResultValues, "font-weight-bold"].join(" ")}>
                        {convertDate(dataToRender.grant_date, GLOBAL_DATE_FORMAT, VARIETY_DATASHEET_DATE_FORMAT)}
                      </Col>

                      {!dataToRender.protectedDesignation ? (
                        <>
                          <Col md="2" className={classes.dataSheetResultKeys}>{t("publication_date")}</Col>
                          <Col md="4" className={classes.dataSheetResultValues}>{convertDate(dataToRender.grant_pub_date, GLOBAL_DATE_FORMAT, VARIETY_DATASHEET_DATE_FORMAT)}</Col>

                          <Col md="2" className={classes.dataSheetResultKeys}>{t("renewal_date")}</Col>
                          <Col md="4" className={[classes.dataSheetResultValues, "font-weight-bold"].join(" ")}>{convertDate(dataToRender.renewal_date, GLOBAL_DATE_FORMAT, VARIETY_DATASHEET_DATE_FORMAT)}</Col>

                          <Col md="12" className={[classes.dataSheetResultValues, "font-weight-bold"].join(" ")}>{t("expiration")}</Col>

                          <Col md="2" className={classes.dataSheetResultKeys}>{t("expiration_actual")}</Col>
                          <Col md="4" className={[classes.dataSheetResultValues, "font-weight-bold"].join(" ")}>{convertDate(dataToRender.end_date, GLOBAL_DATE_FORMAT, VARIETY_DATASHEET_DATE_FORMAT)}</Col>

                          <Col md="2" className={classes.dataSheetResultKeys}>{t("future_calc_expiration_date")}</Col>
                          <Col md="4" className={classes.dataSheetResultValues}>{convertDate(dataToRender.future_exp_date, GLOBAL_DATE_FORMAT, VARIETY_DATASHEET_DATE_FORMAT)}</Col>
                        </>
                      ):(
                        <></>
                      )}
                    </Row>
                  </Collapse>
                </Container>
                <Container className={[classes.region, "parties-container"].join(" ")}>
                  <Row className={classes.regionHeader}>
                    <Col md="3" className={classes.title}>{t("parties")}</Col>
                    <Col md="8" className={classes.summary}>
                      {!dataToRender.protectedDesignation ?
                        collapseSummary(openRegionParties,
                          partiesConditionalHeader(dataToRender.breeder,
                            dataToRender.applicant,
                            dataToRender.maintainer,
                            dataToRender.titleholder,
                            dataToRender.other_parties,
                            t))
                        :collapseSummary(openRegionParties, dataToRender.titleholder)}
                    </Col>
                    <Col md="1" className={classes.collapseButton}>
                      <Button
                        onClick={() => setOpenRegionParties(!openRegionParties)}
                        className={openRegionParties?"open":""}
                        style={{'padding': '0 5px', 'background': '#E8E8E8', 'borderBottomLeftRadius': '0px', 'borderBottomRightRadius': '0px'}}
                        variant="link">
                          <FontAwesomeIcon icon={['fas', FONTAWESOME_ICON_NAMES.CHEVRON_UP]} className={classes.paginationChevron} />
                      </Button>
                    </Col>
                  </Row>
                  <Collapse in={openRegionParties}>
                    <Row>

                      {!dataToRender.protectedDesignation && dataToRender.publicationtypeid !== "EUTM" ? (
                        <>
                          <Col md="2" className={classes.dataSheetResultKeys}>{t("breeders_name")}</Col>
                          <Col md="10" className={classes.dataSheetResultValues}>{dataToRender.breeder}</Col>
                        </>
                      ) : (
                        <></>
                      )}

                      {!dataToRender.protectedDesignation ? (
                        <>
                          <Col md="2" className={classes.dataSheetResultKeys}>{t("applicant")}</Col>
                          <Col md="10" className={classes.dataSheetResultValues}>{dataToRender.applicant}</Col>
                        </>
                      ) : (
                        <></>
                      )}

                      {!dataToRender.protectedDesignation && dataToRender.publicationtypeid !== "EUTM" ? (
                        <>
                          <Col md="2" className={classes.dataSheetResultKeys}>{t("maintainer")}</Col>
                          <Col md="10" className={classes.dataSheetResultValues}>{dataToRender.maintainer}</Col>
                        </>
                      ) : (
                        <></>
                      )}

                      {dataToRender.publicationtypeid !== "EUTM" ? (
                        <>
                          <Col md="2" className={classes.dataSheetResultKeys}>{t("holder")}</Col>
                          <Col md="10" className={classes.dataSheetResultValues}>{dataToRender.titleholder}</Col>
                        </>
                      ) : (
                        <></>
                      )}

                      {!dataToRender.protectedDesignation && dataToRender.publicationtypeid !== "EUTM" ? (
                        <>
                          <Col md="2" className={classes.dataSheetResultKeys}>{t("other_parties")}</Col>
                          <Col md="10" className={classes.dataSheetResultValues}>{dataToRender.other_parties}</Col>
                        </>
                      ) : (
                        <></>
                      )}
                    </Row>
                  </Collapse>
                </Container>
                {dataToRender.remark || dataToRender.extra_data_url ? (
                  <Container className={classes.region}>
                    <Row className={classes.regionHeader}>
                      <Col md="11" className={classes.title}>{t("additional_info")}</Col>
                      <Col md="1" className={classes.collapseButton}>
                        <Button
                          onClick={() => setOpenRegionAdditionalInformation(!openRegionAdditionalInformation)}
                          className={openRegionAdditionalInformation?"open":""}
                          style={{'padding': '0 5px', 'background': '#E8E8E8', 'borderBottomLeftRadius': '0px', 'borderBottomRightRadius': '0px'}}
                          variant="link">
                            <FontAwesomeIcon icon={['fas', FONTAWESOME_ICON_NAMES.CHEVRON_UP]} className={classes.paginationChevron} />
                        </Button>
                      </Col>
                    </Row>
                    <Collapse in={openRegionAdditionalInformation}>
                      <Row>
                        <Col md="2" className={classes.dataSheetResultKeys}>{t("remarks")}</Col>
                        <Col md="10" className={classes.dataSheetResultValues} style={{fontWeight: 400, whiteSpace: 'pre-wrap'}}>{dataToRender.remark}</Col>

                        <Col md="2" className={classes.dataSheetResultKeys}>{t("database_origin_link")}</Col>
                        <Col md="10" className={classes.dataSheetResultValues}>
                          <a target="_blank"  rel="noopener noreferrer" href={prefixCheck(dataToRender.extra_data_url)}>{dataToRender.extra_data_url}</a>
                        </Col>
                      </Row>
                    </Collapse>
                  </Container>
                ) : <></>}
                {denominationsArray?.length || synonymsArray?.length || tradenamesArray?.length || trademarksArray?.length ?
                  <Container className={classes.region}>
                    <Row className={classes.regionHeader}>
                      <Col md="3" className={classes.title}>
                        <span>
                            {t("names")}
                        </span>
                      </Col>
                      <Col md="8" className={classes.summary}>
                        {collapseSummary(openNames,
                          denominationsArray?.length > 1 ? t("several_denominations") : (denominationsArray?.length ? denominationsArray?.[0]?.name : t("no_denominations" )))}
                      </Col>
                      <Col md="1" className={classes.collapseButton}>
                        <Button
                          onClick={() => setOpenNames(!openNames)}
                          className={openNames?"open":""}
                          style={{'padding': '0 5px', 'background': '#E8E8E8', 'borderBottomLeftRadius': '0px', 'borderBottomRightRadius': '0px'}}
                          variant="link">
                            <FontAwesomeIcon
                              icon={['fas',
                              FONTAWESOME_ICON_NAMES.CHEVRON_UP]} className={classes.paginationChevron}
                            />
                        </Button>
                      </Col>
                    </Row>
                    <Collapse in={openNames}>
                      <Row>
                        {denominationsArray?.length ? (
                          <>
                            <Col md="12" className={classes.dataSheetResultValues}>{t("denomination_s")}</Col>
                            {denominationsArray?.map((item: any, index: number) =>
                              <Container
                                key={`denominations-list-${index}`}
                                className={[
                                            classes.denoDataSheet,
                                            classes.borderBottomDashed,
                                            classes.namesDatasheetPaddingBottom
                                          ].concat(getNamesSectionClasses(index, denominationsArray.length)).join(" ")}>
                                <Row key={`container-names-${index}`} style={{paddingTop: '0px'}}>
                                  <Col md="2" className={classes.dataSheetResultKeys}>
                                    {dataToRender.protectedDesignation ?
                                      t("name")
                                      : t("denomination")}
                                  </Col>
                                  <Col md="4" className={classes.dataSheetResultValues}>{item?.name}</Col>

                                  {!dataToRender.protectedDesignation ? (
                                    <>
                                      <Col md="2" className={classes.dataSheetResultKeys}>{t("type")}</Col>
                                      <Col md="4" className={classes.dataSheetResultValues}>{item?.type}</Col>
                                    </>
                                  ):(
                                    <></>
                                  )}

                                  <Col md="2" className={classes.dataSheetResultKeys}>{t("status")}</Col>
                                  <Col md="4" className={classes.dataSheetResultValues}>{denominationStatusMatching(item?.status)}</Col>

                                  {!dataToRender.protectedDesignation ? (
                                    <>
                                      <Col md="2" className={classes.dataSheetResultKeys}>{t("proposal_date")}</Col>
                                      <Col md="4" className={classes.dataSheetResultValues}>{convertDate(item?.prop_dt, GLOBAL_DATE_FORMAT, 'YYYYMMDD')}</Col>
                                      <Col md="2" className={classes.dataSheetResultKeys}>{t("approval_date")}</Col>
                                      <Col md="4" className={classes.dataSheetResultValues}>{convertDate(item?.appr_dt, GLOBAL_DATE_FORMAT, 'YYYYMMDD')}</Col>
                                      <Col md="2" className={classes.dataSheetResultKeys}>{t("publication_date")}</Col>
                                      <Col md="4" className={classes.dataSheetResultValues}>{convertDate(item?.pub_dt, GLOBAL_DATE_FORMAT, 'YYYYMMDD')}</Col>
                                      <Col md="2" className={classes.dataSheetResultKeys}></Col>
                                      <Col md="4" className={classes.dataSheetResultValues}></Col>
                                      <Col md="2" className={classes.dataSheetResultKeys}>{t("end_date")}</Col>
                                      <Col md="4" className={classes.dataSheetResultValues}>{convertDate(item?.end_date, GLOBAL_DATE_FORMAT, 'YYYYMMDD')}</Col>
                                    </>
                                  ):(
                                    <></>
                                  )}
                                </Row>
                              </Container>
                            )}
                          </>
                        ):<></>}
                        {synonymsArray?.length ? (
                          <>
                            <Col md="12" className={classes.dataSheetResultValues}>{t("synonym_s")}</Col>
                            {synonymsArray?.map((item: any, index: number) =>
                              <Container
                                key={`synonyms-list-${index}`}
                                className={[
                                            classes.denoDataSheet,
                                            index === synonymsArray.length - 1 ? classes.namesDatasheetPaddingBottom : ""
                                          ].concat(getNamesSectionClasses(index, synonymsArray.length)).join(" ")}>
                                <Row key={`container-names-${index}`} style={{paddingTop: '0px'}}>
                                  <Col md="12" className={[classes.dataSheetResultKeys, index === 0 ? "" : "pt-0"].join(" ")}>{item?.name}</Col>
                                </Row>
                              </Container>
                            )}
                          </>
                        ):<></>}
                        {tradenamesArray?.length ? (
                          <>
                            <Col md="12" className={classes.dataSheetResultValues}>{t("tradename_s")}</Col>
                            {tradenamesArray?.map((item: any, index: number) =>
                              <Container
                                key={`tradenames-list-${index}`}
                                className={[
                                            classes.denoDataSheet,
                                            index === tradenamesArray.length - 1 ? classes.namesDatasheetPaddingBottom : ""
                                          ].concat(getNamesSectionClasses(index, tradenamesArray.length)).join(" ")}>
                                <Row key={`container-names-${index}`} style={{paddingTop: '0px'}}>
                                <Col md="12" className={[classes.dataSheetResultKeys, index === 0 ? "" : "pt-0"].join(" ")}>{item?.name}</Col>
                                </Row>
                              </Container>
                            )}
                          </>
                        ):<></>}
                        {trademarksArray?.length ? (
                          <>
                            <Col md="12" className={classes.dataSheetResultValues}>{t("trademark_s")}</Col>
                            {trademarksArray?.map((item: any, index: number) =>
                              <Container
                                key={`trademarks-list-${index}`}
                                className={[
                                            classes.denoDataSheet,
                                            index === trademarksArray.length - 1 ? classes.namesDatasheetPaddingBottom : ""
                                          ].concat(getNamesSectionClasses(index, trademarksArray.length)).join(" ")}>
                                <Row key={`container-names-${index}`} style={{paddingTop: '0px'}}>
                                  <Col md="2" className={[classes.dataSheetResultKeys, index === 0 ? "" : "pt-0"].join(" ")}>{t("name")}</Col>
                                  <Col md="10" className={classes.dataSheetResultValues}>{item?.name}</Col>
                                </Row>
                              </Container>
                            )}
                          </>
                        ):<></>}
                      </Row>
                    </Collapse>
                  </Container>
                :<></>}
              </Row>
          </Container>
        </>
        ):<div className="text-center">{error?(
          fromSearchVarieties?
            (t("variety_datasheet_searchresults_error", {name: name}))
            :
            (t("variety_datasheet_mytests_error", {name: name}))
          ):<Spinner animation="border" variant="primary" />}</div>}
      </>
  )
};

export default React.memo(
  VarietyDataSheet,
  (prevProps, nextProps) =>
    nextProps.show === prevProps.show &&
    nextProps.children === prevProps.children
);

export interface IVarietyDataSheet {
  applicationnumber: string;
  applicant: string;
  app_date: string;
  app_pub_date: string;
  breeder: string;
  breeder_ref: string;
  country: string;
  countryid: string;
  crop_sectors: Array<string>;
  end_date: string;
  extra_data_url: string;
  future_exp_date: string;
  grant_date: string;
  grant_number: string;
  grant_pub_date: string;
  maintainer: string;
  name: string;
  other_names: Array<string>;
  other_parties: string;
  pub_name: string;
  pub_type_name: string;
  publicationtypeid: string;
  publicationextraid: number;
  remark: string;
  reg_status: string;
  renewal_date: string;
  species_code: string;
  species_classes: Array<string>;
  species_princ_bot_name: string;
  titleholder: string;
  varietyid: number;
  websiteurl: string;
  denominationsList: string;
}

interface IVarietyDataSheetParams {
  applicationnumber: string
  countryid: string
  publicationextraid: string
  publicationtype: string
  varietyid: string
  name:string
}

const VARIETY_DATASHEET_DATE_FORMAT = "DDMMYYYY";

const joinNotEmptyValues = (delimiter: string, ...values: any) => {
  return [...values].filter(Boolean).join(delimiter);
}

const regStatusConditionalHeader = (regStatus: string, endDate: string, renewalDate: string, grantDate: string, appDate: string) => {
  let output = "";
  switch (regStatus) {
    case varietyStatus.EXPIRED:
    case varietyStatus.SURRENDERED:
    case varietyStatus.TERMINATED:
    case varietyStatus.WITHDRAWN:
    case varietyStatus.REJECTED:
      output = endDate;
      break;
    case varietyStatus.REGISTERED:
      output = renewalDate?renewalDate:grantDate;
      break;
    case varietyStatus.APPLICATION:
      output = appDate;
      break;
    default:
      break;
  }
  return output;
}

const partiesConditionalHeader = (breeder: string, applicant: string, maintainer: string, holder: string, otherParties: string, t: any) => {
  if (breeder) {
    return `${breeder} (${t("breeder")})`
  } else if (applicant) {
    return `${applicant} (${t("applicant")})`
  } else if (maintainer) {
    return `${maintainer} (${t("maintainer")})`
  } else if (holder) {
    return `${holder} (${t("holder")})`
  } else if (otherParties) {
    return `${otherParties} (${t("other_party")})`
  } else {
    return "";
  }
}
